import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle, } from "../../../../components/BladeHeader";
import { CTA } from "../../../../components/CTA";
export const riotProductSkin = (chroma, palette) => css `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 2560px;
  min-height: 884px;
  ${chroma.mediaQueries.tabletDown} {
    min-height: 800px;
  }
  ${chroma.mediaQueries.mobileDown} {
    max-width: 661px;
  }

  .platform-selection-masthead-logo {
    img {
      width: auto;
      height: 48px;
      ${chroma.mediaQueries.tabletDown} {
        height: 32px;
      }
      ${chroma.mediaQueries.mobileDown} {
        height: 24px;
      }
    }

    padding-bottom: ${chroma.spacers.variable.s};
  }

  .gradient-container {
    pointer-events: none;
  }

  .platform-selection-masthead-ctas {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: ${chroma.spacers.variable.s};
    padding: ${chroma.spacers.variable.m};

    div {
      flex: 1;

      a {
        display: block;
        width: 100%;

        .cta-content {
          justify-content: center;
        }
      }
    }
    ${chroma.mediaQueries.tabletDown} {
      display: flex;
      width: 100%;
      max-width: 440px;
      flex-direction: column;
    }
  }

  .platform-selection-masthead-link-label {
    p {
      margin-bottom: 0.2rem;
    }
  }

  ${BladeContent} {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    position: relative;
    height: 100%;
    flex-grow: 1;
  }

  ${BladeHeader} {
    display: flex;
    flex-direction: column;
    gap: ${chroma.spacers.variable.s};
  }

  ${BladeHeaderBody} {
    ${chroma.typography.display3}
    color: ${palette.bladetext1};
    text-transform: none;
  }

  ${BladeHeaderSupertitle} {
    color: ${palette.bladetext2};
    ${chroma.typography.body3};
  }

  ${BladeHeaderTitle} {
    color: ${palette.bladetext1};
    ${chroma.typography.display3};
  }

  ${CTA} {
    ${chroma.mediaQueries.desktopOnly} {
      text-wrap: nowrap;
    }
  }
`;
//# sourceMappingURL=index.js.map